export default "__VITE_ASSET__ir_ubGUe__"